
<div class="flex-box">
  <div class="flex-heading">
    <div class="list-header col-xs-12">
      <span class="pR25">Open Tickets <span *ngIf="queueCount > 0" class="text-primary">({{queueCount}})</span></span>
      <button class="btn btn-sm btn-primary ml-3" (click)="fetchQueueCount()" title="Refresh Queue Count">
        <i class="fa fa-refresh"></i> Get Tickets Count
      </button>
    </div>
  </div>
  <div class="flex-content scroll-x">
    <div class="list-view">
      <div class="list-sidebar">
        <div class="header">
          <div class="title">Filters</div>
          <button class="btn-xxs btn-secondary" (click)="resetFilters()">Reset</button>
        </div>
        <div class="content p-0">
          <div class="px-3 bdr-top">
            <div class="flex mb-3">
              <label class="mr-3">Auto Refresh</label>
              <label data-testid="auto-refresh-switch" class="i-switch i-switch-sm bg-success">
                <input type="checkbox" [(ngModel)]="autoRefresh" (ngModelChange)="toggleAutoRefresh()" name="autoRefresh"/><i></i>
              </label>
            </div>
          </div>
          <div class="px-3 bdr-top">
            <collapse data-testid="sidebar-filter" [title]="this.appConfig.Shared.ListSideBar.Types.LANGUAGES" [iconClass]="this.appConfig.Shared.ListSideBar.Icons.LANGUAGES">
              <language-filter (updatedLanguageList)="updateLanguageFilter($event)" [reset]="resetLanguageFilter"></language-filter>
            </collapse>
          </div>
          <div class="px-3 bdr-top" *ngIf="teams.includes(appConfig.Shared.Role.Name.DOCTOR)">
            <collapse data-testid="sidebar-filter" [title]="this.appConfig.Shared.ListSideBar.Types.DOCTOR" [iconClass]="this.appConfig.Shared.ListSideBar.Icons.DOCTOR">
              <doctor-filter (updatedDoctorList)="updateDoctorFilter($event)" [reset]="resetDoctorFilter"></doctor-filter>
            </collapse>
          </div>
          <div class="px-3 bdr-top">
            <collapse data-testid="sidebar-filter" [title]="this.appConfig.Shared.ListSideBar.Types.TEAMS" [iconClass]="this.appConfig.Shared.ListSideBar.Icons.TEAMS">
              <team-filter (updatedTeamList)="updateTeamFilter($event)" [reset]="resetTeamFilter"></team-filter>
            </collapse>
          </div>
          <div class="px-3 bdr-top" *ngIf="teams.includes(appConfig.Shared.Role.Name.CHAT_SUPPORT)">
            <collapse data-testid="sidebar-filter" [title]="this.appConfig.Shared.ListSideBar.Types.OPERATOR" [iconClass]="this.appConfig.Shared.ListSideBar.Icons.OPERATOR">
              <operator-filter (updatedOperatorList)="updateOperatorFilter($event)" [reset]="resetOperatorFilter"></operator-filter>
            </collapse>
          </div>
          <div class="px-3 bdr-top">
            <collapse data-testid="sidebar-filter" [title]="this.appConfig.Shared.ListSideBar.Types.LABELS" [iconClass]="this.appConfig.Shared.ListSideBar.Icons.LABELS">
              <label-filter [defaultLabels]="regimenLabels" (updatedLabelList)="updateLabelFilter($event)" [reset]="resetLabelFilter"></label-filter>
            </collapse>
          </div>
        </div>
      </div>
      <div class="list-content">
        <ag-grid-angular class="ag-theme-balham" style="height: 100%;" [columnDefs]="columnDefs" [components]="components" [rowBuffer]="0" [rowModelType]="ui.grid.rowModelType" [paginationPageSize]="ui.grid.pageSize" [cacheBlockSize]="ui.grid.pageSize" [cacheOverflowSize]="1" [maxConcurrentDatasourceRequests]="1" [infiniteInitialRowCount]="1" [maxBlocksInCache]="10" (gridReady)="onGridReady($event)"></ag-grid-angular>
      </div>
    </div>
  </div>
</div>